import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_URL = 'https://taijitsu-dromois.fr'
const SITE_NAME = 'Taï-Jitsu Drômois'
const DEFAULT_DESCRIPTION = 'Club de Taï-Jitsu à Loriol-sur-Drôme : art martial, self-défense, cours adultes et jeunes dans une ambiance conviviale.'

interface RouteSeo {
  title: string
  description: string
  index?: boolean
}

const publicPages: Record<string, RouteSeo> = {
  '/': { title: 'Taï-Jitsu Drômois | Art martial & self-défense à Loriol', description: DEFAULT_DESCRIPTION },
  '/club': { title: 'Découvrir le club | Taï-Jitsu Drômois', description: 'Découvrez le Taï-Jitsu Drômois, ses entraînements, ses valeurs et la vie du club en photos et en vidéos.' },
  '/bureau': { title: 'Le bureau | Taï-Jitsu Drômois', description: 'Rencontrez les bénévoles et responsables qui animent le club de Taï-Jitsu Drômois.' },
  '/boutique': { title: 'Boutique du club | Taï-Jitsu Drômois', description: 'Découvrez les vêtements, accessoires et équipements proposés par le Taï-Jitsu Drômois.' },
  '/contact': { title: 'Cours d’essai et contact | Taï-Jitsu Drômois', description: 'Contactez le Taï-Jitsu Drômois et réservez un cours d’essai à Loriol-sur-Drôme.' },
  '/login': { title: 'Espace membre | Taï-Jitsu Drômois', description: 'Connexion à l’espace adhérent du Taï-Jitsu Drômois.', index: false },
}

const privatePage: RouteSeo = {
  title: `Espace privé | ${SITE_NAME}`,
  description: 'Espace réservé aux adhérents du Taï-Jitsu Drômois.',
  index: false,
}

const setMeta = (selector: string, attributes: Record<string, string>) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector)
  if (!element) {
    element = document.createElement('meta')
    document.head.appendChild(element)
  }
  Object.entries(attributes).forEach(([name, value]) => element?.setAttribute(name, value))
}

const SeoMetadata = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const seo = publicPages[pathname] || privatePage
    const canonicalPath = publicPages[pathname] ? pathname : '/'
    const canonicalUrl = `${SITE_URL}${canonicalPath === '/' ? '/' : canonicalPath}`
    document.title = seo.title

    setMeta('meta[name="description"]', { name: 'description', content: seo.description })
    setMeta('meta[name="robots"]', { name: 'robots', content: seo.index === false ? 'noindex, nofollow' : 'index, follow' })
    setMeta('meta[property="og:title"]', { property: 'og:title', content: seo.title })
    setMeta('meta[property="og:description"]', { property: 'og:description', content: seo.description })
    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' })
    setMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl })
    setMeta('meta[property="og:image"]', { property: 'og:image', content: `${SITE_URL}/logo-taijitsu.jpeg` })
    setMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'fr_FR' })
    setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: SITE_NAME })
    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' })

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical) }
    canonical.href = canonicalUrl
  }, [pathname])

  return null
}

export default SeoMetadata
